<div class="filters__sort">
  <app-ph-input
    type="radio"
    [validation]="'base'"
    name="ranking_sort"
    [correctForm]="form"
    [initValue]="'most_donated'"
    (phInputChange)="changeSortRank($event)"
  >
    <app-ph-radio name="ranking_sort" [value]="'most_donated'">
      <span
        class="btn btn--md btn--primary"
        [ngClass]="{ 'btn--outline': form.value.ranking_sort !== 'most_donated' }"
        >{{ 'PROJECTS.FILTERS.most_supported' | translate }}</span
      >
    </app-ph-radio>
    <app-ph-radio name="ranking_sort" [value]="'most_supported'">
      <span
        class="btn btn--md btn--primary"
        [ngClass]="{ 'btn--outline': form.value.ranking_sort !== 'most_supported' }"
        >{{ 'RANKING.most_generous' | translate }}</span
      >
    </app-ph-radio>
  </app-ph-input>
</div>
